


import React, { useState, useContext, useEffect } from "react";
import { useParams } from 'react-router-dom';
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Link, Chip  } from '@mui/material';
import dayjs from "dayjs";
import "dayjs/locale/es";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { CircularProgress, Divider, FormControl, TextField } from '@mui/material';
import AddAlertOutlinedIcon from '@mui/icons-material/AddAlertOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import BreadcrumbStandard from "../GeneralComponents/BreadcrumbStandard";

import PageError from "../GeneralComponents/PageError";
import {DAYS} from "../../Constants/Constants";

const DataTable = ({ data, firstColumnMinWidth }: { data: any; firstColumnMinWidth?: string }) => {
  return (
    <TableContainer component={Paper} sx={{ marginBottom: '16px', boxShadow: 'none' }}>
      <Table sx={{ minWidth: 650, borderCollapse: 'collapse' }} size="small" aria-label="table">
        <TableBody>
          {Object.entries(data).map(([key, value], rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell sx={{ width: firstColumnMinWidth || '150px', maxWidth: firstColumnMinWidth || '150px', border: 'none', p: 0 }}>
                {key}:
              </TableCell>
              <TableCell sx={{ border: 'none' }}>
                <strong> {value} </strong>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);

export default function ContingenciasPreview() {
  const { userSesion, setPageTitle, setDrawerHidding } = useContext(GeneralContext);


  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [documentVisible, setDocumentVisible] = useState(true);

  const [formData, setFormData] = useState({

  });

  const [table1Data, setTable1Data] = useState({"ID": '0000-00', "Origen": 'No envío de datos en las últimas 24 horas'});
const [table2Data, setTable2Data] = useState({"Operador": 'Entel', "Desde": '  2025-03-10 14:00:20', "Hasta": '  2025-03-10 14:00:20', "Zona(s)": 'ZONA03 - ZONA04 - ZONA05'});
const [table3Data, setTable3Data] = useState({"Tipo de Evento": 'Externo', "Impacto o gravedad": 'Alta'});

    const links = [
    { name: 'Inicio', path: '/home' },
    { name: 'Listado de Alertas', path: '/alarmas_lista' },
    { name: 'Detalle Alerta', path: '/alarmas_detalle/'+id },
  ];


const fetchData = (query) => {
    setLoading(true);
    axios
        .getAlarma(id)
        .then((response) => {
            const datos = response.data[0];
            setFormData({
                ...datos,
                fecha_activacion: datos["fecha_activacion"].replace("T", " "),
                fecha_alarma: datos["fecha_activacion"].split("T")[0],
            });

        setTable1Data({
        "ID": datos.id || 'N/A',
        "Origen": datos.fuente_alarma || 'Desconocido'
      });

      setTable2Data({
        "Operador": datos.nombre_operador || 'Sin operador',
        "Desde": datos.fecha_activacion || 'N/A',
        "Hasta":  datos.fecha_desactivacion || 'Activa',
        "Zona(s)": datos.nombre_zona || 'N/A'
      });

      setTable3Data({
        "Tipo de Evento": datos.tipo_evento || 'N/A',
        "Impacto o gravedad": datos.gravedad || 'N/A'
      });
        })
        .catch((error) => {
            console.error("Error al obtener los datos:", error);
            setDocumentVisible(true);
        })
        .finally(() => {
            setLoading(false);
        });
};

const getColor = () => {
  if (formData.afectado==="OPERADOR"){
    return '#1FB2C9';
  }else if(formData.afectado==="TECNOLOGÍA"){
    return '#E57B0A';
  }
  return '#CE4CC5';

}

  useEffect(() => {
    fetchData("");
  }, []);

      useEffect(() => {
        setDrawerHidding(false)
    }, [setPageTitle, setDrawerHidding]);

  return (
    <PageBody>
          <BreadcrumbStandard links={links} />
      <PageBgBlock pad="0" >
      {loading ?
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                width: '100%',
                backgroundColor: 'white'
              }}
            >
              <CircularProgress />
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cargando...
              </Typography>
            </Box>
            :
             documentVisible ? 
             (

      <PageBgBlock pad="2rem 9rem" >
      <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          margin: '0 auto',

          width: '100%',
          minWidth: 400,
          backgroundColor: 'white',
          minHeight: 575,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            backgroundColor: '#FCF7E9',
            padding: '22px 22px 32px',
            zIndex: 1,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '0 0 16px 16px',
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Box
              sx={{ display: 'flex', gap: 1.25, padding: '10px 0', alignItems: 'center', justifyContent: 'space-between', paddingRight: '4rem', marginBottom: '20px' }}
            >
              <Chip label={formData.afectado} sx={{fontWeight: 500, color: 'white', backgroundColor: getColor(),  display: 'flex' }}>
                
              </Chip>
              <Box>
                <svg id="5583:14581" layer-name="sagec-logo 1" width="69" height="20" viewBox="0 0 69 20" fill="none" xmlns="http://www.w3.org/2000/svg" sx={{width: "69px", height: "20px"}}>
                     <g clip-path="url(#clip0_5583_14581)">
                        <path d="M17.3561 17.31C16.6008 17.31 15.8892 17.1985 15.2232 16.9754C14.5552 16.7523 13.9744 16.4407 13.4789 16.0387C12.9834 15.6387 12.6166 15.1675 12.3808 14.629C12.2618 14.4116 12.2599 14.2116 12.3728 14.027C12.4858 13.8443 12.6702 13.7231 12.9298 13.6654C13.13 13.6193 13.3243 13.6462 13.5146 13.7424C13.7029 13.8404 13.8456 13.9866 13.9388 14.1809C14.0914 14.4905 14.3332 14.7675 14.6643 15.0136C14.9953 15.2598 15.3937 15.4579 15.8595 15.606C16.3253 15.7541 16.8248 15.8291 17.3561 15.8291C17.9468 15.8291 18.48 15.7368 18.9577 15.5541C19.4354 15.3714 19.8199 15.104 20.1093 14.7559C20.3987 14.4059 20.5434 13.9808 20.5434 13.475C20.5434 12.8346 20.2897 12.2672 19.7823 11.7749C19.2748 11.2825 18.4601 10.9729 17.3382 10.8478C15.9091 10.6998 14.7891 10.2805 13.9744 9.59388C13.1598 8.90727 12.7534 8.05912 12.7534 7.05133C12.7534 6.31856 12.9596 5.69158 13.3738 5.17038C13.7861 4.64917 14.353 4.25106 15.0746 3.97603C15.7941 3.701 16.6088 3.56445 17.5186 3.56445C18.2025 3.56445 18.813 3.66254 19.3521 3.85679C19.8893 4.05104 20.3551 4.31837 20.7516 4.65494C21.146 4.99344 21.4869 5.38001 21.7704 5.81467C21.9131 6.04354 21.9686 6.25894 21.9389 6.45896C21.9091 6.65898 21.8001 6.81669 21.6118 6.93208C21.3997 7.04748 21.1777 7.06864 20.9478 7.00132C20.7179 6.93401 20.5434 6.8013 20.4245 6.60705C20.2481 6.29741 20.0241 6.02815 19.7525 5.79928C19.481 5.57042 19.1599 5.38771 18.7872 5.24923C18.4146 5.11268 17.9745 5.04344 17.4671 5.04344C16.5691 5.0319 15.8318 5.20115 15.253 5.55118C14.6742 5.90122 14.3848 6.42434 14.3848 7.12249C14.3848 7.48983 14.4819 7.83025 14.6761 8.14566C14.8704 8.46108 15.2133 8.7361 15.7029 8.97074C16.1925 9.20538 16.8803 9.37463 17.7664 9.47848C19.1936 9.64004 20.2857 10.0593 21.0429 10.7421C21.7981 11.4229 22.1767 12.3191 22.1767 13.4308C22.1767 14.0732 22.0499 14.6328 21.7962 15.1136C21.5424 15.5945 21.1916 15.9983 20.7416 16.3253C20.2937 16.6523 19.7763 16.8984 19.1916 17.0638C18.6068 17.2292 17.9963 17.3119 17.358 17.3119L17.3561 17.31Z" fill="#444444"></path>
                        <path d="M23.1461 17.1373C22.8389 17.1373 22.6089 17.0123 22.4563 16.7585C22.3037 16.5065 22.2918 16.243 22.4206 15.968L27.4851 4.2688C27.6377 3.90146 27.8974 3.71875 28.2641 3.71875C28.6526 3.71875 28.9202 3.90146 29.061 4.2688L34.1433 16.0026C34.2602 16.2776 34.2404 16.5354 34.0818 16.7758C33.9233 17.0162 33.6894 17.1373 33.3821 17.1373C33.2295 17.1373 33.0808 17.095 32.9401 17.0085C32.7994 16.9219 32.6923 16.7989 32.621 16.6392L28.0342 5.71317H28.5476L23.9271 16.6392C23.8557 16.8104 23.7507 16.9373 23.6079 17.0181C23.4652 17.0989 23.3126 17.1393 23.1481 17.1393L23.1461 17.1373ZM24.1729 14.0967L24.829 12.7388H31.8578L32.4961 14.0967H24.1749H24.1729Z" fill="#444444"></path>
                        <path d="M40.8351 17.3098C39.8797 17.3098 38.9857 17.1348 38.1532 16.7867C37.3207 16.4366 36.5952 15.9481 35.9748 15.3173C35.3543 14.6884 34.8687 13.9537 34.5139 13.119C34.1591 12.2824 33.9827 11.3842 33.9827 10.4226C33.9827 9.46097 34.1571 8.58203 34.506 7.75119C34.8548 6.92034 35.3405 6.19142 35.9668 5.56059C36.5932 4.93168 37.3187 4.43741 38.1453 4.08352C38.9718 3.72772 39.8678 3.55078 40.8371 3.55078C41.7231 3.55078 42.5021 3.6681 43.1741 3.90274C43.846 4.13738 44.514 4.51818 45.1741 5.04516C45.2692 5.11439 45.3366 5.19132 45.3783 5.27787C45.4199 5.36442 45.4377 5.44904 45.4318 5.53559C45.4258 5.62213 45.406 5.70483 45.3703 5.78369C45.3584 5.95486 45.2851 6.09526 45.1483 6.20488C45.0116 6.31451 44.851 6.36836 44.6607 6.36836C44.4704 6.36836 44.294 6.30489 44.1295 6.17988C43.6815 5.801 43.2098 5.51636 42.7122 5.32018C42.2167 5.12593 41.5903 5.02785 40.8351 5.02785C40.0799 5.02785 39.4396 5.17209 38.8073 5.45673C38.175 5.7433 37.618 6.1318 37.1343 6.62415C36.6507 7.11651 36.2721 7.68964 36.0005 8.34163C35.729 8.99361 35.5942 9.68791 35.5942 10.4207C35.5942 11.1534 35.729 11.8785 36.0005 12.5247C36.2721 13.1729 36.6487 13.7441 37.1343 14.2422C37.618 14.7403 38.175 15.1269 38.8073 15.4019C39.4396 15.6769 40.1156 15.8135 40.8351 15.8135C41.4615 15.8135 42.0502 15.7135 42.6052 15.5135C43.1602 15.3135 43.6855 15.0288 44.181 14.6634C44.3693 14.5268 44.5596 14.4653 44.7479 14.4826C44.9362 14.4999 45.0968 14.5749 45.2256 14.7057C45.3545 14.8384 45.4199 15.0173 45.4199 15.2461C45.4199 15.35 45.404 15.45 45.3763 15.5462C45.3466 15.6443 45.2792 15.7327 45.1721 15.8116C44.5576 16.3386 43.8817 16.7194 43.1443 16.954C42.407 17.1886 41.6359 17.306 40.8331 17.306L40.8351 17.3098ZM45.4219 15.2481L43.8282 14.9211V11.7093H41.2613C41.0254 11.7093 40.8272 11.64 40.6686 11.5035C40.51 11.3669 40.4287 11.1938 40.4287 10.988C40.4287 10.7822 40.508 10.613 40.6686 10.4803C40.8272 10.3495 41.0254 10.2822 41.2613 10.2822H44.6072C44.855 10.2822 45.0532 10.3572 45.1999 10.5053C45.3466 10.6534 45.4219 10.8438 45.4219 11.0727V15.2481Z" fill="#444444"></path>
                        <path d="M47.9353 17.1374C47.6994 17.1374 47.5012 17.0604 47.3426 16.9047C47.1841 16.7508 47.1028 16.5585 47.1028 16.3296V4.52847C47.1028 4.28807 47.1821 4.09382 47.3426 3.9438C47.5012 3.79571 47.6994 3.7207 47.9353 3.7207H56.0623C56.2982 3.7207 56.4924 3.79186 56.647 3.93611C56.7997 4.08035 56.877 4.26499 56.877 4.49385C56.877 4.69964 56.7997 4.87466 56.647 5.01698C56.4944 5.16123 56.2982 5.23239 56.0623 5.23239H48.7678V9.63089H54.0266C54.2743 9.63089 54.4726 9.70205 54.6192 9.84629C54.7659 9.99054 54.8413 10.1694 54.8413 10.3867C54.8413 10.6041 54.7679 10.7848 54.6192 10.9272C54.4726 11.0714 54.2743 11.1426 54.0266 11.1426H48.7678V15.6276H56.0623C56.2982 15.6276 56.4924 15.6988 56.647 15.843C56.7997 15.9873 56.877 16.1604 56.877 16.3661C56.877 16.595 56.7997 16.7816 56.647 16.9239C56.4944 17.0681 56.2982 17.1393 56.0623 17.1393H47.9353V17.1374Z" fill="#444444"></path>
                        <path d="M64.4033 17.3098C63.4479 17.3098 62.552 17.1348 61.7214 16.7867C60.8889 16.4366 60.1634 15.9481 59.543 15.3173C58.9226 14.6884 58.4369 13.9537 58.0821 13.119C57.7273 12.2824 57.5509 11.3842 57.5509 10.4226C57.5509 9.46097 57.7253 8.58203 58.0742 7.75119C58.4231 6.92034 58.9087 6.19142 59.5351 5.56059C60.1614 4.93168 60.8869 4.43741 61.7135 4.08352C62.5401 3.72772 63.436 3.55078 64.4053 3.55078C65.2914 3.55078 66.0703 3.6681 66.7423 3.90274C67.4143 4.13738 68.0823 4.51818 68.7423 5.04516C68.8375 5.11439 68.9049 5.19132 68.9465 5.27787C68.9881 5.36442 69.006 5.44904 69 5.53559C68.9941 5.62213 68.9743 5.70483 68.9386 5.78369C68.9267 5.95486 68.8533 6.09333 68.7166 6.19527C68.5798 6.29912 68.4212 6.35297 68.2389 6.35874C68.0565 6.36451 67.8761 6.30489 67.6997 6.17796C67.2517 5.79907 66.778 5.51443 66.2824 5.31826C65.7869 5.12401 65.1605 5.02592 64.4053 5.02592C63.6501 5.02592 63.0099 5.17017 62.3775 5.45481C61.7452 5.74138 61.1882 6.12988 60.7046 6.62223C60.2209 7.11459 59.8423 7.68772 59.5708 8.3397C59.2992 8.99169 59.1644 9.68599 59.1644 10.4187C59.1644 11.1515 59.2992 11.8766 59.5708 12.5228C59.8423 13.1709 60.2209 13.7421 60.7046 14.2403C61.1882 14.7384 61.7452 15.125 62.3775 15.4C63.0099 15.675 63.6858 15.8116 64.4053 15.8116C65.0317 15.8116 65.6204 15.7135 66.1754 15.5115C66.7304 15.3115 67.2557 15.0269 67.7512 14.6615C67.9396 14.5249 68.1298 14.4653 68.3182 14.4807C68.5065 14.498 68.667 14.573 68.7959 14.7038C68.9247 14.8365 68.9901 15.0153 68.9901 15.2442C68.9901 15.35 68.9723 15.4481 68.9366 15.5442C68.9009 15.6423 68.8355 15.7308 68.7423 15.8097C68.1279 16.3251 67.4519 16.704 66.7146 16.9444C65.9772 17.1848 65.2061 17.306 64.4033 17.306V17.3098ZM45.4219 15.2481L43.8282 14.9211V11.7093H41.2613C41.0254 11.7093 40.8272 11.64 40.6686 11.5035C40.51 11.3669 40.4287 11.1938 40.4287 10.988C40.4287 10.7822 40.508 10.613 40.6686 10.4803C40.8272 10.3495 41.0254 10.2822 41.2613 10.2822H44.6072C44.855 10.2822 45.0532 10.3572 45.1999 10.5053C45.3466 10.6534 45.4219 10.8438 45.4219 11.0727V15.2481Z" fill="#444444"></path>
                        <path d="M4.1015 6.42055L3.25125 6.4073C1.55245 6.38083 0.153178 7.69559 0.125898 9.34389L-7.2131e-05 16.9552C-0.0273523 18.6035 1.32769 19.9612 3.02649 19.9876L3.87674 20.0009C5.57555 20.0273 6.97482 18.7126 7.0021 17.0643L7.12807 9.45299C7.15535 7.80469 5.80031 6.44702 4.1015 6.42055Z" fill="#F4A7AA"></path>
                        <path d="M7.93158 0.0142994L7.08133 0.00105161C5.38253 -0.0254175 3.98326 1.28934 3.95598 2.93764L3.83001 10.5489C3.80273 12.1972 5.15777 13.5549 6.85657 13.5814L7.70682 13.5946C9.40563 13.6211 10.8049 12.3063 10.8322 10.658L10.9581 3.04674C10.9854 1.39844 9.63039 0.0407685 7.93158 0.0142994Z" fill="#96ABBE"></path>
                     </g>
                     <defs>
                        <clipPath id="clip0_5583_14581">
                           <rect width="69" height="20" fill="white"></rect>
                        </clipPath>
                     </defs>
                  </svg>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 1.25, padding: '10px 0', alignItems: 'center' }}>
              {formData.gravedad === "Alta"  ? (
                <WarningAmberOutlinedIcon sx={{ color: '#FB3B3B', fontSize: 32 }} />
              ) : (
                <AddAlertOutlinedIcon sx={{ color: 'inherit', fontSize: 32 }} />
              )}
              <Typography sx={{ fontSize: 24, fontWeight: 700, color: '#27272a' }}>
                Alerta gravedad: {formData.gravedad}
              </Typography>
            </Box>

            <Typography sx={{ width: 333, fontSize: 20, fontWeight: 500, color: '#171717' }}>
              No envío de datos en las últimas 3 horas
            </Typography>
          </Box>
          <Box
            component="img"
            src="/assets/img-autenticacion.jpg"
            alt="Complementary graphic"
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 24,
              height: 194,
              width: 190,
              overflow: 'hidden',
            }}
          />
        </Box>

        <Box sx={{ position: 'relative', padding: 3, marginTop: '-40px', zIndex: 2 }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#1e3a8a', textTransform: 'none', fontWeight: 500, fontSize: 14, px: 2, py: 1, mb: 2 }}
          >
            Ir al Reporte
          </Button>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: 16, color: '#171717', padding: '32px 0 20px', borderBottom: '2px solid #eee', mb: 2 }}>
            <div>{formData.responsable} (SAGEC Admin)</div>
            <div style={{ minWidth: '150px' }}>fecha: <strong>{formData.fecha_alarma}</strong></div>
          </Box>

          <DataTable data={table1Data} firstColumnMinWidth="150px" />
          <DataTable data={table2Data} firstColumnMinWidth="150px" />
          <DataTable data={table3Data} firstColumnMinWidth="180px" />

              <TableContainer component={Paper} sx={{ marginBottom: '16px', boxShadow: 'none' }}>
            <Table sx={{ minWidth: 650, borderCollapse: 'collapse' }} aria-label="simple table">
              <TableBody>
               
                  <TableRow key={"grafana-link"}>
                    <TableCell sx={{ width: '150px', maxWidth: '150px', border: 'none', p: 0 }}>
                      URL Grafana:
                    </TableCell>
                    <TableCell sx={{ border: 'none', p: 0 }}>
                    <Link href="https://sagec.subtel.gob.cl/service/grafana/d/be3tzf1qwhlogb/alerta-operadores?orgId=1&var-Operador=GTD%20MANQUEHUE%20S.A." underline="always">
                      https://sagec.subtel.gob.cl/service/grafana/d/be3tzf1qwhlogb/alerta-operadores?orgId=1&var-Operador=GTD%20MANQUEHUE%20S.A.
                    </Link>
                        
                    </TableCell>
                  </TableRow>

              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
             </PageBgBlock>) : (
            <PageError>
                  El documento al que intenta acceder no esta disponible.
                </PageError>
          )
        }
      </PageBgBlock>

    </PageBody>
  );
}
